import UserProductsSubMenusLinks from "@/components/menu/sub-menus/products/UserProductsSubMenusLinks.vue";
import ProductDetails from "@/components/products/WineComponent.vue";
export default {
  name: "UserSpiritDetails",
  components: {
    UserProductsSubMenusLinks: UserProductsSubMenusLinks,
    ProductDetails: ProductDetails
  },
  props: {
    loggedUserData: Object
  },
  data: function data() {
    return {
      id: null,
      returnRoute: "",
      routeParam: ""
    };
  },
  created: function created() {
    this.id = this.$route.params.id;
    this.searchCriterias = this.$route.params.searchCriterias;
    this.returnRoute = this.$route.params.returnRoute;
    this.routeParam = this.$route.params.routeParam;
  }
};